import { userUtils } from '../../utils/auth';
import { useCallback } from 'react';
import { initAllAnalytics } from '../../utils/analytics';
import CookieConsentUi from './CookieConsentUi';

export default function CookieConsentWithAnalytics() {
    const user = userUtils.getUser();

    const handleAccept = useCallback(async () => {
        if (user) {
            const { id, email, name } = user
            await initAllAnalytics({
                userData: {
                    id,
                    email,
                    name,
                },
            });
        } else {
            await initAllAnalytics();
        }
    }, [user]);

    const handleDecline = useCallback(async() => {
        await initAllAnalytics({
            mixpanelOptions: {
                track_pageview: false,
                autocapture: false,
            }
        });
    }, [user]);

    return (
        <CookieConsentUi onAccept={handleAccept} onDecline={handleDecline} />
    );
}
